"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.callListenersForAblyMessageWithcommand = exports.unregisterFromAblyMessagesWithcommand = exports.registerForAblyMessagesWithcommand = exports.hideBottomBar = exports.setHideBottomBarFn = exports.setGlobalBackButtonFunc = exports.setGlobalBackButtonFuncFunc = exports.storeHostName = exports.askUserForAppRating = exports.updateContent = exports.setContentUpdateFn = exports.setMenuOpen = exports.setSetMenuOpenFn = exports.getAppInstance = exports.setAppInstance = void 0;

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _ArrayHelper = require("../helpers/ArrayHelper");

var _AppUtilsStrings = require("./AppUtilsStrings");

var _MuiAlertHelper = require("../helpers/MuiAlertHelper");

var _DeviceInfoHelper = _interopRequireDefault(require("../helpers/DeviceInfoHelper"));

var _DataStore = _interopRequireWildcard(require("../KESI2/Stores/DataStore2"));

var _DeviceTracking = _interopRequireDefault(require("../tracking/DeviceTracking"));

var appInstance = null;
var backButtonFn;
var contentUpdateFn = null;
var hideBottomBarFn = null;
var setMenuOpenFn = null;
var ablyListeners = {};

var setAppInstance = function setAppInstance(instance) {
  appInstance = instance;
};

exports.setAppInstance = setAppInstance;

var getAppInstance = function getAppInstance() {
  return appInstance;
};
/**
 * This function must only be called by App class (or equivalent)
 * @param syncFn
 */


exports.getAppInstance = getAppInstance;

var setSetMenuOpenFn = function setSetMenuOpenFn(syncFn) {
  setMenuOpenFn = syncFn;
};

exports.setSetMenuOpenFn = setSetMenuOpenFn;

var setMenuOpen = function setMenuOpen(open) {
  setMenuOpenFn(open);
};
/**
 * This function must only be called by App class (or equivalent)
 * @param asyncFn
 */


exports.setMenuOpen = setMenuOpen;

var setContentUpdateFn = function setContentUpdateFn(asyncFn) {
  contentUpdateFn = asyncFn;
};

exports.setContentUpdateFn = setContentUpdateFn;

var updateContent = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(goHome) {
    var updateWithoutFurtherDialog,
        _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            updateWithoutFurtherDialog = _args.length > 1 && _args[1] !== undefined ? _args[1] : true;
            return _context.abrupt("return", contentUpdateFn(goHome, updateWithoutFurtherDialog));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function updateContent(_x) {
    return _ref.apply(this, arguments);
  };
}();
/**
 *
 * @param bundleId
 * @param appleAppId
 * @param forceExternal {boolean}  iOS supports in-app ratings unless this value is set to true
 * @returns {Promise<*|Promise<any>>}
 * @private
 */


exports.updateContent = updateContent;

var _reallyAskUserForAppRating = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(bundleId, appleAppId, forceExternal) {
    var id;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            id = _DeviceInfoHelper["default"].isiOS() ? appleAppId : bundleId;

            if (!(!forceExternal && window.LaunchReview.isRatingSupported())) {
              _context2.next = 4;
              break;
            }

            if (!window.LaunchReview.isRatingSupported()) {
              _context2.next = 4;
              break;
            }

            return _context2.abrupt("return", new _promise["default"](function (resolve, reject) {
              window.LaunchReview.rating(resolve, reject);
            }));

          case 4:
            return _context2.abrupt("return", new _promise["default"](function (resolve, reject) {
              window.LaunchReview.launch(resolve, reject, id || undefined);
            }));

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function _reallyAskUserForAppRating(_x2, _x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 *  Options, each value is optional:
 *  {
 *      title: string,
 *      message: string,
 *      posButton: string,
 *      negButton: string,
 *      bundleId: string,
 *      appleAppId: string
 *  }
 */


var askUserForAppRating = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
    var options,
        title,
        message,
        posCaption,
        negCaption,
        cancelButton,
        okButton,
        _args3 = arguments;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            options = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};

            if (window.LaunchReview) {
              _context3.next = 4;
              break;
            }

            console.error('Launch Review plugin missing');
            return _context3.abrupt("return");

          case 4:
            title = options.title || (0, _AppUtilsStrings.getString)('ASK_USER_FOR_REVIEW_TITLE');
            message = options.message || (0, _AppUtilsStrings.getString)('ASK_USER_FOR_REVIEW_MESSAGE');
            posCaption = options.posButton || (0, _AppUtilsStrings.getString)('ASK_USER_FOR_REVIEW_POSITIVE_BUTTON');
            negCaption = options.negButton || (0, _AppUtilsStrings.getString)('ASK_USER_FOR_REVIEW_NEGATIVE_BUTTON');
            cancelButton = {
              label: negCaption
            };
            okButton = {
              label: posCaption,
              callback: function callback() {
                return _reallyAskUserForAppRating(options.bundleId, options.appleAppId, options.forceExternal);
              }
            };
            (0, _MuiAlertHelper.showAlertWithOptions)({
              title: title,
              message: message,
              buttons: [cancelButton, okButton]
            });

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function askUserForAppRating() {
    return _ref3.apply(this, arguments);
  };
}();

exports.askUserForAppRating = askUserForAppRating;

var storeHostName = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
    var options,
        hostName,
        _args4 = arguments;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            options = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
            hostName = options.hostname;
            _context4.next = 4;
            return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.EQUEO_HOST_NAME, hostName);

          case 4:
            _context4.next = 6;
            return _DeviceTracking["default"].trackNow();

          case 6:
            (0, _MuiAlertHelper.showAlertWithOptions)({
              title: 'QR Code gescannt',
              message: 'Der QR Code wurde erfolgreich gescannt.'
            });

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function storeHostName() {
    return _ref4.apply(this, arguments);
  };
}();
/**
 * This function must only be called by App class (or equivalent)
 * @param asyncFn
 */


exports.storeHostName = storeHostName;

var setGlobalBackButtonFuncFunc = function setGlobalBackButtonFuncFunc(asyncFn) {
  backButtonFn = asyncFn;
};

exports.setGlobalBackButtonFuncFunc = setGlobalBackButtonFuncFunc;

var setGlobalBackButtonFunc = function setGlobalBackButtonFunc(func) {
  if (backButtonFn) {
    backButtonFn(func);
  }
};

exports.setGlobalBackButtonFunc = setGlobalBackButtonFunc;

var setHideBottomBarFn = function setHideBottomBarFn(asyncFn) {
  hideBottomBarFn = asyncFn;
};

exports.setHideBottomBarFn = setHideBottomBarFn;

var hideBottomBar = function hideBottomBar(hide) {
  return hideBottomBarFn(hide);
};

exports.hideBottomBar = hideBottomBar;

var registerForAblyMessagesWithcommand = function registerForAblyMessagesWithcommand(command, callback) {
  if (!ablyListeners.command) {
    ablyListeners[command] = [];
  }

  if (ablyListeners[command].indexOf(callback) < 0) {
    ablyListeners[command].push(callback);
  }
};

exports.registerForAblyMessagesWithcommand = registerForAblyMessagesWithcommand;

var unregisterFromAblyMessagesWithcommand = function unregisterFromAblyMessagesWithcommand(command, callback) {
  if (ablyListeners[command]) {
    (0, _ArrayHelper.removeElement)(ablyListeners[command], callback);
  }
};

exports.unregisterFromAblyMessagesWithcommand = unregisterFromAblyMessagesWithcommand;

var callListenersForAblyMessageWithcommand = function callListenersForAblyMessageWithcommand(command, message) {
  if (ablyListeners[command]) {
    ablyListeners[command].forEach(function (callback) {
      callback(message);
    });
    return true;
  } else {
    return false;
  }
};

exports.callListenersForAblyMessageWithcommand = callListenersForAblyMessageWithcommand;